import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { FormErrorMessage, Heading } from '@treams/treams-ui';

import PlainHorizontalCard, { PlainHorizontalCardPadding } from './PlainHorizontalCard';

interface IProps {
	error: Error;
	title?: string;
}

const Element = styled.div`
	img {
		width: 600px;
		max-width: 100%;
	}
`;

export default function ErrorStateCard({ error, title }: IProps) {
	const { t } = useTranslation();

	return (
		<PlainHorizontalCard padding={PlainHorizontalCardPadding.Large}>
			<Element>
				<Flex alignItems="center" flexDirection="column">
					<Box p={3} textAlign="center">
						<Heading>{title ?? t('common.errorState.pageTitle')}</Heading>
						<FormErrorMessage error={error} />
					</Box>
				</Flex>
			</Element>
		</PlainHorizontalCard>
	);
}
